import { render, staticRenderFns } from "./HotelReviewCard.vue?vue&type=template&id=500dd20b&scoped=true&"
import script from "./HotelReviewCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HotelReviewCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HotelReviewCard.vue?vue&type=style&index=0&id=500dd20b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500dd20b",
  null
  
)

export default component.exports